import { render } from "./IconoAmbiente.vue?vue&type=template&id=38830cc8"
import script from "./IconoAmbiente.vue?vue&type=script&lang=js"
export * from "./IconoAmbiente.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__